import lang from 'lang'
import config from '@/config'
import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'

import { checkRequiredVatFieldsAreSet } from '@/modules/taxForms/_helper/vatSettingsValidator'

import { toast } from '@/modules/base/components/toast/toastConfig'

const taxOfficeUrl = `${config.resourceHost}taxoffice/bufa`
// actions
const ACTION_PREFIX = 'taxForms/settings'

const SET_COMPANY = `${ACTION_PREFIX}/SET_COMPANY`
const SET_TAX_NUMBER = `${ACTION_PREFIX}/SET_TAX_NUMBER`
const SET_BUSINESS_IDENTIFICATION_NUMBER = `${ACTION_PREFIX}/SET_BUSINESS_IDENTIFICATION_NUMBER`
const SET_TAX_OFFICE = `${ACTION_PREFIX}/SET_TAX_OFFICE`
const SET_TAX_OFFICE_ID = `${ACTION_PREFIX}/SET_TAX_OFFICE_ID`
const DO_LOAD_SETTINGS = `${ACTION_PREFIX}/DO_LOAD_SETTINGS`
const SET_IS_VALID = `${ACTION_PREFIX}/SET_IS_VALID`
const RESET = `${ACTION_PREFIX}/RESET`

// reducer
const initialState = {
  loadSettings: true,
  isValid: false,
  validationMessages: [],
  taxNumber: '',
  businessIdentificationNumber: '',
  taxOffice: '',
  taxOfficeId: '',
  company: {
    companyName: '',
    city: '',
    street: '',
    zipCode: '',
    countryIso: '',
    email: '',
    website: '',
    phone1: '',
    phone2: '',
    mobile: '',
    fax: '',
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DO_LOAD_SETTINGS:
      const { loadSettings } = action
      return { ...state, loadSettings }

    case SET_COMPANY:
      const { company } = action
      return { ...state, company: { ...state.company, ...company } }

    case SET_TAX_NUMBER:
      const { taxNumber } = action
      return { ...state, taxNumber }

    case SET_BUSINESS_IDENTIFICATION_NUMBER:
      const { businessIdentificationNumber } = action
      return { ...state, businessIdentificationNumber }

    case SET_TAX_OFFICE:
      const { taxOffice } = action
      return { ...state, taxOffice }

    case SET_TAX_OFFICE_ID:
      const { taxOfficeId } = action
      return { ...state, taxOfficeId }

    case SET_IS_VALID:
      const { isValid, validationMessages } = action
      return { ...state, isValid, validationMessages }

    case RESET:
      return { ...initialState }

    default:
      return state
  }
}

// action creators

const setCompany = (company) => ({
  type: SET_COMPANY,
  company,
})

const setTaxNumber = (taxNumber) => ({
  type: SET_TAX_NUMBER,
  taxNumber,
})

const setBusinessIdentificationNumber = (businessIdentificationNumber) => ({
  type: SET_BUSINESS_IDENTIFICATION_NUMBER,
  businessIdentificationNumber,
})

const setTaxOffice = (taxOffice) => ({
  type: SET_TAX_OFFICE,
  taxOffice,
})

const setTaxOfficeId = (taxOfficeId) => ({
  type: SET_TAX_OFFICE_ID,
  taxOfficeId,
})

const setSettingsAreValid = (isValid, messages = []) => ({
  type: SET_IS_VALID,
  isValid,
  validationMessages: messages,
})

const checkSettingsAreValid = () => {
  return (dispatch, getState) => {
    const { taxForms: { settings: { taxNumber, taxOfficeId, company } } } = getState()
    const validationResult = checkRequiredVatFieldsAreSet({ ...company, taxNumber, taxOfficeId })
    dispatch(setSettingsAreValid(validationResult.isValid, validationResult.messages))
  }
}

export const reset = () => ({
  type: RESET,
})

export const doLoadSettings = (value) => ({
  type: DO_LOAD_SETTINGS,
  loadSettings: value,
})

export const fetchAccountSettingsAndTaxOfficeExp = () => {
  return (dispatch) => {
    dispatch(setSettingsAreValid(false))
    request(settingsConfig.account, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { companyAddress: company, taxNumber, businessIdentificationNumber, taxOfficeId },
          },
        } = response

        dispatch(setCompany(company))
        dispatch(setTaxNumber(taxNumber))
        dispatch(setBusinessIdentificationNumber(businessIdentificationNumber))
        dispatch(setTaxOfficeId(taxOfficeId))
        if (taxOfficeId) return request(`${taxOfficeUrl}/${taxOfficeId}`)
      })
      .then((response) => {
        if (response && response.body.data && response.body.data.name) {
          dispatch(setTaxOffice(response.body.data.name))
        } else {
          dispatch(setTaxOffice('zu PLZ nicht gefunden'))
        }
      })
      .then(() => {
        dispatch(checkSettingsAreValid())
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      })
      .done(() => {
        dispatch(doLoadSettings(false))
      })
  }
}
